import { render } from "./echarts.vue?vue&type=template&id=5afd50d6"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"

import "./echarts.vue?vue&type=style&index=0&id=5afd50d6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__